import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import UiuxHero from "../Components/uiux/UiuxHero";
import UiuxServices from "../Components/uiux/UiuxServices";
import UiuxWhyChoose from "../Components/uiux/UiuxWhyChoose";
import HowWeWork from "../Components/home/HowWeWork";
import TrustedIndustries from "../Components/home/TrustedIndustries";

// Redesigned (Tailwind) page for /service/ui-ux-design-services.
const UiuxDesignPage = () => (
  <div>
    <SEOPage
      title="UI/UX Design Company in Noida | User-Centric UI/UX Design Services | DataMetricks"
      description="DataMetricks creates user-centric UI/UX designs: user research, UX strategy, UI design, prototyping and usability testing that are beautiful, intuitive and drive real business results."
      canonicalUrl="https://www.datametricks.com/service/ui-ux-design-services"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <UiuxHero />
      <UiuxServices />
      <UiuxWhyChoose />
      <HowWeWork />
      <TrustedIndustries />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default UiuxDesignPage;
